var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 35,
    viewBox: "0 0 47 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0723 29.6026C26.2895 29.6026 32.9508 22.9758 32.9508 14.8013C32.9508 6.62677 26.2895 0 18.0723 0C9.85519 0 3.19385 6.62677 3.19385 14.8013C3.19385 22.9758 9.85519 29.6026 18.0723 29.6026Z",
    fill: "url(#paint0_radial_16903_33426)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1185 17.5666C19.6534 17.5666 20.8977 16.3288 20.8977 14.8019C20.8977 13.2749 19.6534 12.0371 18.1185 12.0371C16.5836 12.0371 15.3394 13.2749 15.3394 14.8019C15.3394 16.3288 16.5836 17.5666 18.1185 17.5666Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1281 25.54V33.8954H9.02843V26.1357C9.02843 24.4555 7.96897 23.6612 6.64849 23.6612C5.14375 23.6612 4.09967 24.5319 4.09967 26.4565V33.8801H0V14.8477H4.09967V21.5686C4.83668 20.5604 6.20323 19.9036 8.01505 19.9036C10.7789 19.9189 13.1281 21.8741 13.1281 25.54Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.938 20.3008H20.0376V33.9106H15.938V20.3008Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1752 25.5404V33.8957H32.0755V26.1361C32.0755 24.4558 31.0161 23.6616 29.6956 23.6616C28.1909 23.6616 27.1468 24.5322 27.1468 26.4568V33.8804H23.0471V20.2705H27.1468V21.5536C27.8838 20.5455 29.2503 19.8887 31.0621 19.8887C33.8259 19.9192 36.1752 21.8744 36.1752 25.5404Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1901 24.2118V29.0234C44.1901 30.1996 45.2035 30.3065 46.9999 30.1996V33.8961C41.6412 34.446 40.0751 32.8421 40.0751 29.0234V24.2118H37.8794V20.3015H40.0751V17.72L44.1747 16.498V20.3015H46.9846V24.2118H44.1901Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_16903_33426",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.0651 14.7974) scale(14.8759 14.7987)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.50967e-7,
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9617,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.d69f0f98ebfad6bb558f6dc32e304c89.svg";
export { ForwardRef as ReactComponent };